import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors } from '../../themes/colors';

export type PillToggleOption = {
  value: any;
  label: string;
};

export type PillToggleProps = {
  options: PillToggleOption[];
  value: any;
  setValue: (value: any) => void;
  disabled?: boolean;
};

export const PillToggle = (props: PillToggleProps) => {
  const onPress = (option: PillToggleOption) => {
    const selected = props.options.filter((o) => o === option)[0];
    props.setValue(selected.value);
  };

  return (
    <View style={styles.container}>
      {props.options.map((option) => (
        <TouchableOpacity
          key={option.value}
          style={[
            styles.option,
            props.value === option.value && styles.selected,
          ]}
          onPress={() => onPress(option)}
          disabled={props.disabled}
        >
          <Text
            style={
              props.value === option.value ? styles.selectedText : styles.text
            }
          >
            {option.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 10,
    borderRadius: 25,
    overflow: 'hidden',
    padding: 1,
    gap: 18,
  },
  option: {
    flex: 1,
    borderRadius: 25,
    paddingVertical: 15,
    paddingHorizontal: 20,
    backgroundColor: Colors.white,
    borderColor: Colors.info,
    borderWidth: 1,
  },
  selected: {
    backgroundColor: '#007BFF',
  },
  text: {
    color: Colors.info,
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 16,
  },
  selectedText: {
    color: Colors.white,
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 16,
  },
});
